import React from 'react'
import SucriptionComponent from '../Components/SucriptionComponent'
import Layout from '../Components/Layout/Layout'

const Subcription = () => {
  return (
    <>
    <Layout>
        <SucriptionComponent />
    </Layout>
    </>
  )
}

export default Subcription


